export const environment = {
    production: true,
    apiUrlV1: 'https://nvapigateway.onlinevidyalaya.net/gateway/',
};

